module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.list,
      "search-options": _vm.searchOpts,
      "sort-options": _vm.sortOpts,
      "pagination-options": _vm.pagOpts,
      "group-options": _vm.groupOpts,
      "row-style-class": _vm.rowStyle,
      "compact-mode": _vm.compact,
      "fixed-header": _vm.fixedHeader,
      "line-numbers": _vm.lineNumbers,
      "rtl": _vm.rtl,
      "max-height": _vm.maxHeight,
      "style-class": 'vgt-table' + (_vm.striped ? ' striped' : '') + (_vm.bordered ? ' bordered' : ''),
      "theme": _vm.theme
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a68db89"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/tables/GoodTable.vue
// module id = 1350
// module chunks = 0